// extracted by mini-css-extract-plugin
export default {"layout":"Pages_layout__hj-kY","content":"Pages_content__QPD7o","main":"Pages_main__Qu6nE"};